import type { FieldProps } from 'formik';
import { Field } from 'formik';
import * as React from 'react';

import Dropdown from '@components/Dropdown/Dropdown';

interface FormikDropdownFieldProps {
  name: string;
  options?: {
    k: number | string;
    v: boolean | string;
    disabled?: boolean;
  }[];
  label?: string;
  /** Accessible name to use when the visible label is hidden. */
  ariaLabel?: string;
  required?: boolean;
  labelColor?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
}
const FormikDropdownField: React.FC<FormikDropdownFieldProps> = ({
  ...props
}) => {
  const {
    name,
    label,
    ariaLabel,
    required,
    options: OPTIONS,
    labelColor,
    onChange,
    disabled,
  } = props;

  return (
    <Field name={name}>
      {({
        field,
        meta,
        form: { setFieldValue },
      }: FieldProps<number | string>) => (
        <Dropdown
          ariaLabel={ariaLabel}
          color={labelColor}
          disabled={disabled}
          error={meta.touched ? meta.error : ''}
          label={label}
          required={required}
          {...field}
          onChange={(value) => {
            setFieldValue(field.name, value);
            onChange?.(value);
          }}
        >
          {(OPTIONS ?? []).map((o) => (
            <option disabled={o.disabled} key={o.k} value={o.k}>
              {o.v}
            </option>
          ))}
        </Dropdown>
      )}
    </Field>
  );
};

export default FormikDropdownField;
